import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=5ab04cb0"
import script from "./CategoryPage.vue?vue&type=script&lang=js"
export * from "./CategoryPage.vue?vue&type=script&lang=js"
import style0 from "./CategoryPage.vue?vue&type=style&index=0&id=5ab04cb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports